var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
/**
 * Obtiene el color de texto apropiado basado en el contexto visual
 * Permite personalizar los colores según el contexto (hotSale, chinaDeals, métodos de pago)
 * @param contextoVisual - El contexto visual del componente (hotSale, chinaDeals, metodos-de-pago)
 * @param theme - El objeto theme de styled-components con los colores definidos
 * @returns El color de texto apropiado para el contexto dado
 */
var obtenerColorTexto = function (contextoVisual, theme) {
    // Mapeo de contextos visuales a sus respectivos colores de texto del theme
    var coloresPorContexto = {
        "hotSale": theme.hotSaleBotonTexto,
        "chinaDeals": theme.chinaDealsBotonTexto,
        "metodos-de-pago": theme.descuentosPorMedioDePagoBotonTexto,
    };
    // Retorna el color específico del contexto o el color por defecto
    return contextoVisual && coloresPorContexto[contextoVisual]
        ? coloresPorContexto[contextoVisual]
        : theme.addToCartTexto;
};
/**
 * Obtiene el color de texto en estado hover basado en el contexto visual
 * @param contextoVisual - El contexto visual del componente
 * @param theme - El objeto theme de styled-components
 * @returns El color de texto en hover apropiado para el contexto dado
 */
var obtenerColorTextoHover = function (contextoVisual, theme) {
    // Mapeo de contextos visuales a sus respectivos colores de texto en hover
    var coloresPorContexto = {
        "hotSale": theme.hotSaleBotonTextoHover,
        "chinaDeals": theme.chinaDealsBotonTextoHover,
        "metodos-de-pago": theme.descuentosPorMedioDePagoBotonTextoHover,
    };
    // Retorna el color específico del contexto o el color por defecto
    return contextoVisual && coloresPorContexto[contextoVisual]
        ? coloresPorContexto[contextoVisual]
        : theme.addToCartTextoHover;
};
/**
 * Obtiene el color de fondo apropiado basado en el contexto visual
 * @param contextoVisual - El contexto visual del componente
 * @param theme - El objeto theme de styled-components
 * @returns El color de fondo apropiado para el contexto dado
 */
var obtenerColorFondo = function (contextoVisual, theme) {
    // Mapeo de contextos visuales a sus respectivos colores de fondo
    var coloresPorContexto = {
        "hotSale": theme.hotSaleBotonFondo,
        "chinaDeals": theme.chinaDealsBotonFondo,
        "metodos-de-pago": theme.descuentosPorMedioDePagoBotonFondo,
    };
    // Retorna el color específico del contexto o el color por defecto
    return contextoVisual && coloresPorContexto[contextoVisual]
        ? coloresPorContexto[contextoVisual]
        : theme.addToCartFondo;
};
/**
 * Obtiene el color de fondo en estado hover basado en el contexto visual
 * @param contextoVisual - El contexto visual del componente
 * @param theme - El objeto theme de styled-components
 * @returns El color de fondo en hover apropiado para el contexto dado
 */
var obtenerColorFondoHover = function (contextoVisual, theme) {
    // Mapeo de contextos visuales a sus respectivos colores de fondo en hover
    var coloresPorContexto = {
        "hotSale": theme.hotSaleBotonFondoHover,
        "chinaDeals": theme.chinaDealsBotonFondoHover,
        "metodos-de-pago": theme.descuentosPorMedioDePagoBotonFondoHover,
    };
    // Retorna el color específico del contexto o el color por defecto
    return contextoVisual && coloresPorContexto[contextoVisual]
        ? coloresPorContexto[contextoVisual]
        : theme.addToCartFondoHover;
};
/**
 * Obtiene el color de borde apropiado basado en el contexto visual
 * @param contextoVisual - El contexto visual del componente
 * @param theme - El objeto theme de styled-components
 * @returns El color de borde apropiado para el contexto dado
 */
var obtenerColorBorde = function (contextoVisual, theme) {
    // Mapeo de contextos visuales a sus respectivos colores de borde
    var coloresPorContexto = {
        "hotSale": theme.hotSaleBotonBorder,
        "chinaDeals": theme.chinaDealsBotonBorder,
        "metodos-de-pago": theme.descuentosPorMedioDePagoBotonBorder,
    };
    // Retorna el color específico del contexto o el color por defecto
    return contextoVisual && coloresPorContexto[contextoVisual]
        ? coloresPorContexto[contextoVisual]
        : theme.addToCartBorder;
};
/**
 * Obtiene el color de borde en estado hover basado en el contexto visual
 * @param contextoVisual - El contexto visual del componente
 * @param theme - El objeto theme de styled-components
 * @returns El color de borde en hover apropiado para el contexto dado
 */
var obtenerColorBordeHover = function (contextoVisual, theme) {
    // Mapeo de contextos visuales a sus respectivos colores de borde en hover
    var coloresPorContexto = {
        "hotSale": theme.hotSaleBotonBorderHover,
        "chinaDeals": theme.chinaDealsBotonBorderHover,
        "metodos-de-pago": theme.descuentosPorMedioDePagoBotonBorderHover,
    };
    // Retorna el color específico del contexto o el color por defecto
    return contextoVisual && coloresPorContexto[contextoVisual]
        ? coloresPorContexto[contextoVisual]
        : theme.addToCartBorderHover;
};
/**
 * Styled component para el botón "Más información"
 * Muestra información adicional del producto cuando es requerida
 * Aplica estilos según el contexto visual (hotSale, chinaDeals, etc.)
 */
export var BotonMasInformacion = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 40px;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 0;\n  // Color de texto din\u00E1mico seg\u00FAn contexto visual\n  color: ", ";\n  // Fondo especial para hotSale, blanco por defecto\n  background-color: ", ";\n  border: 1px solid ", ";\n  text-decoration: none;\n  border-radius: ", ";\n  overflow: hidden;\n  // Efectos de hover para mejor UX\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n  }\n"], ["\n  min-height: 40px;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 0;\n  // Color de texto din\u00E1mico seg\u00FAn contexto visual\n  color: ", ";\n  // Fondo especial para hotSale, blanco por defecto\n  background-color: ", ";\n  border: 1px solid ", ";\n  text-decoration: none;\n  border-radius: ", ";\n  overflow: hidden;\n  // Efectos de hover para mejor UX\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n  }\n"])), function (props) { return props.theme.addToCartFondo; }, function (_a) {
    var contextoVisual = _a.contextoVisual, theme = _a.theme;
    return contextoVisual === "hotSale" ? theme.hotSaleColor : theme.addToCartTexto;
}, function (props) { return props.theme.addToCartBorder; }, function (props) { return props.theme.buttonBorderRadius; }, function (props) { return props.theme.addToCartTexto; }, function (props) { return props.theme.addToCartFondo; }, function (props) { return props.theme.addToCartBorderHover; });
/**
 * Contenedor principal para los controles de cantidad
 * Organiza los botones de sumar/restar en un layout horizontal
 * Aplica bordes temáticos según el contexto visual
 */
export var ControladorDeCantidades = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 40px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n  // Bordes superior e inferior que coinciden con el color del fondo de los botones\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  border-radius: ", ";\n"], ["\n  height: 40px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n  // Bordes superior e inferior que coinciden con el color del fondo de los botones\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n  border-radius: ", ";\n"])), function (_a) {
    var contextoVisual = _a.contextoVisual, theme = _a.theme;
    return obtenerColorFondo(contextoVisual, theme);
}, function (_a) {
    var contextoVisual = _a.contextoVisual, theme = _a.theme;
    return obtenerColorFondo(contextoVisual, theme);
}, function (props) { return props.theme.buttonBorderRadius; });
/**
 * Styled component base para todos los botones de control de cantidad
 * Define estilos comunes que son heredados por los botones específicos
 * Maneja estados normales, hover y disabled
 */
export var BotonControlCantidad = styled.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  min-height: 40px;\n  font-size: 14px;\n  cursor: pointer;\n  text-align: center;\n  margin: 0;\n  // Aplicaci\u00F3n de colores din\u00E1micos seg\u00FAn el contexto visual\n  color: ", ";\n  background-color: ", ";\n  border: ", ";\n  // Efectos de hover con colores espec\u00EDficos del contexto\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n    border: 1px solid ", "; \n  }\n  // Estado deshabilitado con colores neutros para indicar inactividad\n  &:disabled {\n    cursor: not-allowed;\n    background-color: silver;\n    color: gray;\n  }\n"], ["\n  min-height: 40px;\n  font-size: 14px;\n  cursor: pointer;\n  text-align: center;\n  margin: 0;\n  // Aplicaci\u00F3n de colores din\u00E1micos seg\u00FAn el contexto visual\n  color: ", ";\n  background-color: ", ";\n  border: ", ";\n  // Efectos de hover con colores espec\u00EDficos del contexto\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n    border: 1px solid ", "; \n  }\n  // Estado deshabilitado con colores neutros para indicar inactividad\n  &:disabled {\n    cursor: not-allowed;\n    background-color: silver;\n    color: gray;\n  }\n"])), function (_a) {
    var contextoVisual = _a.contextoVisual, theme = _a.theme;
    return obtenerColorTexto(contextoVisual, theme);
}, function (_a) {
    var contextoVisual = _a.contextoVisual, theme = _a.theme;
    return obtenerColorFondo(contextoVisual, theme);
}, function (_a) {
    var contextoVisual = _a.contextoVisual, theme = _a.theme;
    return obtenerColorBorde(contextoVisual, theme);
}, function (_a) {
    var contextoVisual = _a.contextoVisual, theme = _a.theme;
    return obtenerColorTextoHover(contextoVisual, theme);
}, function (_a) {
    var contextoVisual = _a.contextoVisual, theme = _a.theme;
    return obtenerColorFondoHover(contextoVisual, theme);
}, function (_a) {
    var contextoVisual = _a.contextoVisual, theme = _a.theme;
    return obtenerColorBordeHover(contextoVisual, theme);
});
/**
 * Botón principal "Agregar al Carrito"
 * Hereda estilos de BotonControlCantidad y añade características específicas
 * Incluye peso de fuente especial para hotSale y espaciado para iconos
 */
export var BotonAgregarAlCarrito = styled(BotonControlCantidad)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border-radius: ", ";\n  padding: 10px 0;\n  // Texto en negrita para hotSale para mayor impacto visual\n  font-weight: ", ";\n  // Espaciado para iconos SVG (ej: carrito de compras)\n  > svg {\n    margin-right: 10px;\n  }\n"], ["\n  border-radius: ", ";\n  padding: 10px 0;\n  // Texto en negrita para hotSale para mayor impacto visual\n  font-weight: ", ";\n  // Espaciado para iconos SVG (ej: carrito de compras)\n  > svg {\n    margin-right: 10px;\n  }\n"])), function (props) { return props.theme.buttonBorderRadius; }, function (_a) {
    var contextoVisual = _a.contextoVisual;
    return contextoVisual === "hotSale" ? "bold" : "normal";
});
/**
 * Botón para decrementar la cantidad en el carrito
 * Posicionado en el lado izquierdo con bordes redondeados específicos
 */
export var BotonRestarAlCarrito = styled(BotonControlCantidad)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  // Bordes redondeados solo en el lado izquierdo para crear efecto visual unificado\n  border-radius: ", " 0 0\n    ", ";\n  padding: 10px 15px;\n"], ["\n  // Bordes redondeados solo en el lado izquierdo para crear efecto visual unificado\n  border-radius: ", " 0 0\n    ", ";\n  padding: 10px 15px;\n"])), function (props) { return props.theme.buttonBorderRadius; }, function (props) { return props.theme.buttonBorderRadius; });
/**
 * Botón para incrementar la cantidad en el carrito
 * Posicionado en el lado derecho con bordes redondeados específicos
 */
export var BotonSumarAlCarrito = styled(BotonControlCantidad)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  // Bordes redondeados solo en el lado derecho para crear efecto visual unificado\n  border-radius: 0 ", "\n    ", " 0;\n  padding: 10px 15px;\n"], ["\n  // Bordes redondeados solo en el lado derecho para crear efecto visual unificado\n  border-radius: 0 ", "\n    ", " 0;\n  padding: 10px 15px;\n"])), function (props) { return props.theme.buttonBorderRadius; }, function (props) { return props.theme.buttonBorderRadius; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
